
<script>

    export default{
        props:[],
        data(){

            return {
                datePickerConfig:{
                    'format':'D/MM/YYYY',
                    'showClose': true
                },
                fromDate: "",
                toDate: "",
                estoques: [],
                ordenacao: 'quantidade',
                ordem: 'desc'

            }
        },
        methods:{
            initDates: function(){

                let m = moment();

                m.set({hour:0,minute:0,second:0,millisecond:0});

                this.toDate = moment();
                this.toDate.set({hour:0,minute:0,second:0,millisecond:0});

                this.fromDate = m;
                this.fromDate.subtract(1,'month');

            },
            loadEstoques: function(){

                $(".loading").show();
                var vm = this;
                let data = {
                    from: moment(this.fromDate,"D/MM/YYYY").format("Y-M-DD"),
                    to: moment(this.toDate,"D/MM/YYYY").format("Y-M-DD"),
                };
                axios.get('/distribuidor/ranking/estoque/list',{
                    params: data
                }).then(function(response){

                    vm.estoques = response.data;
                    $(".loading").hide();
                }).catch(function(error){
                    console.log(error);
                    alert("Erro ao carregar Estoque");
                    $(".loading").hide();
                });
            },
            changeData: function() {
                this.loadEstoques();
            }
        },
        computed:{
            orderedEstoques: function () {
                return _.orderBy(this.estoques, this.ordenacao,this.ordem)
            }
        },
        created: function(){
            this.initDates();
        },
        mounted: function(){
            this.loadEstoques();
        }
    }

</script>

<template>

	<div class="col-md-12">
		<div class="row">
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-3">
						<div class="form-group">
							<label for="">De</label>
							<date-picker  v-model="fromDate" @dp-change="changeData" :config="datePickerConfig"></date-picker>
						</div>
					</div>

					<div class="col-md-3">
						<div class="form-group">
							<label for="">Até</label>
							<date-picker  v-model="toDate" @dp-change="changeData" :config="datePickerConfig"></date-picker>
						</div>
					</div>
					<div class="col-md-3">
						<div class="form-group">
							<label for="">Ordenar por</label>
							<select name="" id="" class="form-control" v-model="ordenacao">
								<option value="quantidade">Quantidade</option>
								<option value="codigo">Código</option>
							</select>
						</div>
					</div>


					<div class="col-md-3">
						<div class="form-group">
							<label for="">Ordem</label>
							<select name="" id="" class="form-control" v-model="ordem">
								<option value="asc">Crescente</option>
								<option value="desc">Decrescente</option>
							</select>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-12 printer">

				<table class="table table-striped">
					<thead>
					<tr>
						<th class="text-center">&nbsp</th>
						<th class="text-center">Código</th>
						<th class="text-left">Produto</th>
						<th class="text-center">Aproveitamento</th>
					</tr>
					</thead>
					<tbody>
					<tr class="text-center" v-for="(estoque,index) in orderedEstoques">
						<td>{{index+1}}</td>
						<td>{{estoque.codigo}}</td>
						<td class="text-left">{{estoque.produto}}</td>
						<td>{{estoque.quantidade}}</td>
					</tr>
					</tbody>
				</table>

			</div>
		</div>

	</div>

</template>

<style scoped="">

	@media only print{

		.filter,.breadcrumb,.navbar{
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor_ranking/Estoque.vue